export * from "ce/pages/UserAuth/ThirdPartyAuth";
import { default as ThirdPartyAuth } from "ce/pages/UserAuth/ThirdPartyAuth";

export const SocialLoginTypes = {};

export default ThirdPartyAuth;
